import { z } from 'zod';
import { request, useQuery, UseQueryResult } from '@applyboard/ui-utils';
import { Deserializer } from 'jsonapi-serializer';

const MarketSchema = z.object({
  id: z.string(),
  displayName: z.string(),
});

const MarketsResponseSchema = z.array(MarketSchema);

type Market = z.infer<typeof MarketSchema>;

async function getMarkets() {
  const response = await request('/api/v2/markets?fields[market]=display_name', {
    schema: MarketsResponseSchema,
    deserializer: new Deserializer({
      keyForAttribute: 'camelCase',
    }),
  });
  return response;
}

export const useMarkets = (): {
  markets: Market[];
  isLoadingMarkets: boolean;
  marketsError: unknown;
} => {
  const { data, isLoading, error }: UseQueryResult<Market[]> = useQuery(
    ['markets', { pkg: 'ab-student-intake-form' }],
    getMarkets,
    {
      refetchOnMount: true,
    },
  );

  return {
    markets: data ?? [],
    isLoadingMarkets: isLoading,
    marketsError: error,
  };
};
